import { HTTP } from '@/common/utils/http';
import { QueryParams} from '@/common/utils/query-params';
import { PaginationParams } from '@/common/utils/pagination-params';

export const CouponsService = {
    getCouponsBySchool(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/coupons`);
        return HTTP.get(url);
    },

    deleteCoupon(schoolId, couponId) {
        return HTTP.delete(`/schools/${schoolId}/coupons/${couponId}`);
    },

    deleteMultipleCoupons(schoolId, couponsIds) {
        return HTTP.delete(`/schools/${schoolId}/coupons?couponsIds=${couponsIds}`);
    },

    getCoupon(schoolId, couponId) {
        return HTTP.get(`/schools/${schoolId}/coupons/${couponId}`);
    },

    addCoupon(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/coupons`, form);
    },

    updateCoupon(schoolId, couponId, form) {
        return HTTP.patch(`/schools/${schoolId}/coupons/${couponId}`, form);
    },

    getCouponUsage(schoolId, couponId) {
        return HTTP.get(`schools/${schoolId}/coupons/${couponId}/uses`);
    },

    getXlsFileFieldNames(schoolId) {
        return HTTP.get(`/schools/${schoolId}/coupons/xls-fields`);
    },

    getCouponsXls(schoolId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/coupons/xls-file`);
        return HTTP.get(url);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/coupons.service.js